/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Cell, FormControl, HFlow } from 'bold-ui'
import { SimNaoRadioGroupField } from 'components/form/field/SimNaoRadioGroupField'
import { MetaRoot } from 'util/metaPath'

import { CuidadoCompartilhadoPlanoModel } from '../model-cuidadocompartilhado'

interface CuidadoCompartilhadoTICFieldsProps {
  path: MetaRoot<CuidadoCompartilhadoPlanoModel>
  required: boolean
  disabled: boolean
}

export default function CuidadoCompartilhadoTICFields({
  path,
  required,
  disabled,
}: Readonly<CuidadoCompartilhadoTICFieldsProps>) {
  return (
    <Cell size={12}>
      <FormControl
        label='Após devida explicação, o cidadão declara concordar de forma livre e esclarecida que o agendamento da consulta com o especialista poderá ser mediado por tecnologia?'
        required={required}
      >
        <HFlow>
          <SimNaoRadioGroupField name={path.cidadaoAceitaAtendTic} disabled={disabled} />
        </HFlow>
      </FormControl>
    </Cell>
  )
}
